import { render } from "./Webhooks.vue?vue&type=template&id=3126806c&scoped=true"
import script from "./Webhooks.vue?vue&type=script&lang=js"
export * from "./Webhooks.vue?vue&type=script&lang=js"

import "./Webhooks.vue?vue&type=style&index=0&id=3126806c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3126806c"

export default script